import {ROUTE_PATH} from 'constants/routes';

export const ROUTE_CONFIG = {
    ONLINE_SESSIONS: {
        SELF: {
            path: ROUTE_PATH.USER.ONLINE._SELF,
            permission: ['online', 'self']
        },
        SESSIONS: {
            path: ROUTE_PATH.USER.ONLINE.SESSIONS,
            permission: ['online', 'sessions']
        },
        CONVERSATIONS: {
            path: ROUTE_PATH.USER.ONLINE.CONVERSATIONS,
            permission: ['online', 'conversations']
        }
    },
    ACCOUNT_ACTIVATION: {
        SELF: {
            path: ROUTE_PATH.USER.ACCOUNT_ACTIVATION._SELF,
            permission: ['accountActivation']
        }
    },
    ACCOUNT_BLOCKED: {
        SELF: {
            path: ROUTE_PATH.USER.ACCOUNT_BLOCKED._SELF,
            permission: ['accountBlocked']
        }
    },
    PASSWORD_EXPIRED: {
        path: ROUTE_PATH.USER.PASSWORD.EXPIRED,
        permission: ['passwordExpired']
    },
    ACTIVITY: {
        SELF: {
            path: ROUTE_PATH.USER.ACTIVITY._SELF,
            permission: ['activity', 'self']
        },
        SESSION_HISTORY: {
            path: ROUTE_PATH.USER.ACTIVITY.SESSION_HISTORY,
            permission: ['activity', 'sessionHistory']
        },
        PRE_SESSION_FLOW: {
            path: ROUTE_PATH.USER.ACTIVITY.PRE_SESSION_FLOW,
            permission: ['activity', 'preSessionFlow']
        },
        DASHBOARD: {
            path: ROUTE_PATH.USER.ACTIVITY.DASHBOARD,
            permission: ['activity', 'dashboard']
        },
        AGENT_STATISTIC: {
            path: ROUTE_PATH.USER.ACTIVITY.AGENTS_STATISTIC,
            permission: ['activity', 'agentStatistic']
        },
        COMPLIANCE: {
            path: ROUTE_PATH.USER.ACTIVITY.COMPLIANCE,
            permission: ['activity', 'compliance']
        }
    },
    CONTENT: {
        SELF: {
            path: ROUTE_PATH.USER.CONTENT._SELF,
            permission: ['content', 'self']
        },
        SESSION_RESULT: {
            path: ROUTE_PATH.USER.CONTENT.SESSION_RESULT,
            permission: ['content', 'sessionResult']
        },
        CLIENT_SESSION: {
            path: ROUTE_PATH.USER.CONTENT.CLIENT_SESSION,
            permission: ['content', 'clientSession']
        }
    },
    ACCOUNT: {
        SELF: {
            path: ROUTE_PATH.USER.ACCOUNT._SELF,
            permission: ['account', 'self']
        },
        MY_PROFILE: {
            path: ROUTE_PATH.USER.ACCOUNT.MY_PROFILE,
            permission: ['account', 'myProfile'],
        },
        SETTINGS: {
            path: ROUTE_PATH.USER.ACCOUNT.SETTINGS,
            permission: ['account', 'settings'],
        },
        INTEGRATION: {
            path: ROUTE_PATH.USER.ACCOUNT.INTEGRATIONS,
            permission: ['account', 'integrations']
        },
        ROLES: {
            path: ROUTE_PATH.USER.ACCOUNT.ROLES,
            permission: ['account', 'roles']
        },
        OUTGOING_MESSAGES: {
            path: ROUTE_PATH.USER.ACCOUNT.OUTGOING_MESSAGES,
            permission: ['account', 'outgoingMessages']
        },
        WORKING_HOURS: {
            path: ROUTE_PATH.USER.ACCOUNT.WORKING_HOURS,
            permission: ['account', 'workingHours']
        },
        CREATE_USER: {
            path: ROUTE_PATH.USER.ACCOUNT.CREATE_USER,
            permission: ['account', 'users', 'currentInfo']
        },
        EDIT_USER: {
            path: ROUTE_PATH.USER.ACCOUNT.EDIT_USER,
            permission: ['account', 'users', 'currentInfo']
        },
        USERS: {
            path: ROUTE_PATH.USER.ACCOUNT.USERS,
            permission: ['account', 'users']
        },
        GROUPS: {
            path: ROUTE_PATH.USER.ACCOUNT.GROUPS,
            permission: ['account', 'groups']
        },
        CLIENTS_CONNECTS: {
            path: ROUTE_PATH.USER.ACCOUNT.CLIENTS_CONNECTS,
            permission: ['account', 'clientConnections']
        },
        LIVE_HELP: {
            path: ROUTE_PATH.USER.ACCOUNT.LIVE_HELP,
            permission: ['account', 'liveHelp']
        },
        SESSION: {
            path: ROUTE_PATH.USER.ACCOUNT.SESSION,
            permission: ['account', 'session']
        },
        APPOINTMENTS: {
            path: ROUTE_PATH.USER.ACCOUNT.APPOINTMENTS,
            permission: ['account', 'appointments']
        },
        BILLING: {
            path: ROUTE_PATH.USER.ACCOUNT.BILLING,
            permission: ['account', 'billing']
        }
    },
    ABOUT: {
        ME: {
            path: ROUTE_PATH.USER.ABOUT.ME,
            permission: ['about', 'me']
        }
    }
};
